import { setAlert } from '../../alert';
import api from '../../../util/api';
import {
    API_GET_ELECTRICITY_PURCHASED_PER_FACILITY,
    API_GET_ELECTRICITY_PURCHASED_PER_GROUP,
    API_GET_FUEL_COMBUSTED_PER_FACILITY,
    API_GET_FUEL_COMBUSTED_PER_GROUP,
    API_GET_LPG_COMBUSTED_PER_GROUP,
    API_GET_LPG_COMBUSTED_PER_FACILITY,
    API_GET_REFRIGERANT_GAS_TOP_UP_PER_GROUP,
    API_GET_REFRIGERANT_GAS_TOP_UP_PER_FACILITY,
    API_GET_DRY_ICE_PURCHASED_PER_GROUP,
    API_GET_DRY_ICE_PURCHASED_PER_FACILITY,
    API_GET_WASTE_GENERATED_PER_GROUP,
    API_GET_WASTE_GENERATED_PER_FACILITY,
    API_GET_PETROL_CARDS_PER_FACILITY,
    API_GET_PETROL_CARDS_PER_GROUP,
    API_GET_CAR_HIRE_PER_FACILITY,
    API_GET_CAR_HIRE_PER_GROUP,
    API_GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY,
    API_GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP,
    API_GET_DOWNSTREAM_DISTRIBUTION_PER_GROUP,
    API_GET_DOWNSTREAM_DISTRIBUTION_PER_FACILITY,
    API_GET_WATER_PER_GROUP,
    API_GET_WATER_PER_FACILITY,
    API_GET_CHEMICALS_AND_ADDITIVES_PER_GROUP,
    API_GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY,
    API_GET_WOODEN_PRODUCTS_PER_GROUP,
    API_GET_WOODEN_PRODUCTS_PER_FACILITY,
    API_GET_PACKAGING_PER_GROUP,
    API_GET_PACKAGING_PER_FACILITY,
    API_GET_WINE_AND_GRAPES_PER_GROUP,
    API_GET_WINE_AND_GRAPES_PER_FACILITY,
    API_GET_OTHER_PER_GROUP,
    API_GET_OTHER_PER_FACILITY,
    API_GET_FERTILIZERS_PER_GROUP,
    API_GET_FERTILIZERS_PER_FACILITY,
    API_GET_AGROCHEMICALS_PER_FACILITY,
    API_GET_AGROCHEMICALS_PER_GROUP,
    API_EXPORT_COMPANY_CONSUMPTION_SUMMARY,
    API_EXPORT_GROUP_CONSUMPTION_SUMMARY,
    API_GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP,
    API_GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY,
    API_GET_RENEWABLE_ENERGY_PER_FACILITY,
    API_GET_RENEWABLE_ENERGY_PER_GROUP
} from '../constants/06-dashboard';
import {
    GET_ELECTRICITY_PURCHASED_PER_FACILITY_FAIL,
    GET_ELECTRICITY_PURCHASED_PER_FACILITY_SUCCESS,
    GET_ELECTRICITY_PURCHASED_PER_GROUP_FAIL,
    GET_ELECTRICITY_PURCHASED_PER_GROUP_SUCCESS,
    // FUEL COMBUSTED PER FACILITY
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_SUCCESS,
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_FAIL,
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_FAIL,
    GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_FAIL,
    // FUEL COMBUSTED PER GROUP
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_FAIL,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_FAIL,
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_FAIL,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_FAIL,
    // LPG COMBUSTED PER GROU[]
    GET_LPG_COMBUSTED_PER_GROUP_SUCCESS,
    GET_LPG_COMBUSTED_PER_GROUP_FAIL,
    // LPG COMBUSTED PER FACILITY
    GET_LPG_COMBUSTED_PER_FACILITY_SUCCESS,
    GET_LPG_COMBUSTED_PER_FACILITY_FAIL,
    // REFRIGERANT GAS TOP UPS PER GROUP
    GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_SUCCESS,
    GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_FAIL,
    // REFRIGERANT GAS TOP UPS PER FACILITY
    GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_SUCCESS,
    GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_FAIL,
    // DRY ICE PURCHASED PER GROUP
    GET_DRY_ICE_PURCHASED_PER_GROUP_SUCCESS,
    GET_DRY_ICE_PURCHASED_PER_GROUP_FAIL,
    // DRY ICE PURCHASED PER FACILITY
    GET_DRY_ICE_PURCHASED_PER_FACILITY_SUCCESS,
    GET_DRY_ICE_PURCHASED_PER_FACILITY_FAIL,
    // WASTE GENERATED PER GROUP
    GET_WASTE_TO_LANDFILL_PER_GROUP_SUCCESS,
    GET_WASTE_TO_RECYCLING_PER_GROUP_SUCCESS,
    GET_WASTE_TO_COMPOSTING_PER_GROUP_SUCCESS,
    GET_WASTEWATER_TREATMENT_PER_GROUP_SUCCESS,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_SUCCESS,
    GET_WASTE_TO_LANDFILL_PER_GROUP_FAIL,
    GET_WASTE_TO_RECYCLING_PER_GROUP_FAIL,
    GET_WASTE_TO_COMPOSTING_PER_GROUP_FAIL,
    GET_WASTEWATER_TREATMENT_PER_GROUP_FAIL,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_FAIL,
    // WASTE GENERATED PER FACILITY
    GET_WASTE_TO_LANDFILL_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_COMPOSTING_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_RECYCLING_PER_FACILITY_SUCCESS,
    GET_WASTEWATER_TREATMENT_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_LANDFILL_PER_FACILITY_FAIL,
    GET_WASTE_TO_COMPOSTING_PER_FACILITY_FAIL,
    GET_WASTE_TO_RECYCLING_PER_FACILITY_FAIL,
    GET_WASTEWATER_TREATMENT_PER_FACILITY_FAIL,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_FAIL,
    // FLIGHTS AND ACCOMMODATION
    GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_FAIL,
    GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_SUCCESS,
    GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_FAIL,
    GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_SUCCESS,
    // CAR HIRE
    GET_CAR_HIRE_DIESEL_PER_GROUP_SUCCESS,
    GET_CAR_HIRE_PETROL_PER_GROUP_SUCCESS,
    GET_CAR_HIRE_DIESEL_PER_GROUP_FAIL,
    GET_CAR_HIRE_PETROL_PER_GROUP_FAIL,
    GET_CAR_HIRE_DIESEL_PER_FACILITY_SUCCESS,
    GET_CAR_HIRE_PETROL_PER_FACILITY_SUCCESS,
    GET_CAR_HIRE_PETROL_PER_FACILITY_FAIL,
    GET_CAR_HIRE_DIESEL_PER_FACILITY_FAIL,
    // PETROL CARDS
    GET_PETROL_CARDS_PETROL_PER_GROUP_SUCCESS,
    GET_PETROL_CARDS_DIESEL_PER_GROUP_SUCCESS,
    GET_PETROL_CARDS_DIESEL_PER_GROUP_FAIL,
    GET_PETROL_CARDS_PETROL_PER_GROUP_FAIL,
    GET_PETROL_CARDS_DIESEL_PER_FACILITY_SUCCESS,
    GET_PETROL_CARDS_PETROL_PER_FACILITY_SUCCESS,
    GET_PETROL_CARDS_DIESEL_PER_FACILITY_FAIL,
    GET_PETROL_CARDS_PETROL_PER_FACILITY_FAIL,
    // DOWNSTREAM DISTRIBUTION
    GET_INTER_DC_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_INTER_DC_DISTRIBUTION_PER_GROUP_FAIL,
    GET_FARM_DC_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_FARM_DC_DISTRIBUTION_PER_GROUP_FAIL,
    GET_SHIPPING_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_SHIPPING_DISTRIBUTION_PER_GROUP_FAIL,
    GET_REGIONAL_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_REGIONAL_DISTRIBUTION_PER_GROUP_FAIL,
    GET_INTER_DC_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_INTER_DC_DISTRIBUTION_PER_FACILITY_FAIL,
    GET_FARM_DC_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_FARM_DC_DISTRIBUTION_PER_FACILITY_FAIL,
    GET_SHIPPING_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_SHIPPING_DISTRIBUTION_PER_FACILITY_FAIL,
    GET_REGIONAL_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_REGIONAL_DISTRIBUTION_PER_FACILITY_FAIL,
    GET_WATER_PER_GROUP_SUCCESS,
    GET_WATER_PER_GROUP_FAIL,
    GET_WATER_PER_FACILITY_SUCCESS,
    GET_WATER_PER_FACILITY_FAIL,
    GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_SUCCESS,
    GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_FAIL,
    GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_SUCCESS,
    GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_FAIL,
    GET_WOODEN_PRODUCTS_PER_GROUP_SUCCESS,
    GET_WOODEN_PRODUCTS_PER_GROUP_FAIL,
    GET_WOODEN_PRODUCTS_PER_FACILITY_SUCCESS,
    GET_WOODEN_PRODUCTS_PER_FACILITY_FAIL,
    GET_PACKAGING_PER_GROUP_SUCCESS,
    GET_PACKAGING_PER_GROUP_FAIL,
    GET_PACKAGING_PER_FACILITY_SUCCESS,
    GET_PACKAGING_PER_FACILITY_FAIL,
    GET_WINE_AND_GRAPES_PER_GROUP_SUCCESS,
    GET_WINE_AND_GRAPES_PER_GROUP_FAIL,
    GET_WINE_AND_GRAPES_PER_FACILITY_SUCCESS,
    GET_WINE_AND_GRAPES_PER_FACILITY_FAIL,
    GET_OTHER_PER_GROUP_SUCCESS,
    GET_OTHER_PER_GROUP_FAIL,
    GET_OTHER_PER_FACILITY_SUCCESS,
    GET_OTHER_PER_FACILITY_FAIL,
    START_LOADING,
    GET_FERTILIZERS_PER_GROUP_SUCCESS,
    GET_FERTILIZERS_PER_GROUP_FAIL,
    GET_FERTILIZERS_PER_FACILITY_SUCCESS,
    GET_FERTILIZERS_PER_FACILITY_FAIL,
    GET_AGROCHEMICALS_PER_FACILITY_SUCCESS,
    GET_AGROCHEMICALS_PER_FACILITY_FAIL,
    GET_AGROCHEMICALS_PER_GROUP_SUCCESS,
    GET_AGROCHEMICALS_PER_GROUP_FAIL,
    EXPORT_COMPANY_CONSUMPTION_SUCCESS,
    EXPORT_COMPANY_CONSUMPTION_FAIL,
    EXPORT_GROUP_CONSUMPTION_SUCCESS,
    EXPORT_GROUP_CONSUMPTION_FAIL,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_SUCCESS,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_FAIL,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_SUCCESS,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_FAIL,
    GET_RENEWABLE_ENERGY_PER_GROUP_SUCCESS,
    GET_RENEWABLE_ENERGY_PER_GROUP_FAIL,
    GET_RENEWABLE_ENERGY_PER_FACILITY_SUCCESS,
    GET_RENEWABLE_ENERGY_PER_FACILITY_FAIL
} from '../types/06-dashboard';

const config = {
    headers: {
        'Content-Type': 'application/json'
    },
    // withCredentials: true,
};

export const getElectricityPurchasedPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ELECTRICITY_PURCHASED_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_ELECTRICITY_PURCHASED_PER_GROUP_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ELECTRICITY_PURCHASED_PER_GROUP_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const getElectricityPurchasedPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ELECTRICITY_PURCHASED_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_ELECTRICITY_PURCHASED_PER_FACILITY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ELECTRICITY_PURCHASED_PER_FACILITY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRenewableEnergyPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_RENEWABLE_ENERGY_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_RENEWABLE_ENERGY_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_RENEWABLE_ENERGY_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getRenewableEnergyPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_RENEWABLE_ENERGY_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_RENEWABLE_ENERGY_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_RENEWABLE_ENERGY_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getFuelCombustedPerGroup = (company, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FUEL_COMBUSTED_PER_GROUP + `/${company}/${year}/${type}`,
            config
        );
        if (type === 'diesel-stationary') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'diesel-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_SUCCESS,
                payload: data,
            });
        }
        if (type === 'petrol-stationary') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'petrol-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'diesel-stationary') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'diesel-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'petrol-stationary') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'petrol-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
};

export const getFuelCombustedPerFacility = (company, group, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FUEL_COMBUSTED_PER_FACILITY + `/${company}/${group}/${year}/${type}`,
            config
        );
        if (type === 'diesel-stationary') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'diesel-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_SUCCESS,
                payload: data,
            });
        }
        if (type === 'petrol-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'diesel-stationary') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'diesel-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'petrol-mobile') {
            dispatch({
                type: GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
};


export const getLpgCombustedPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_LPG_COMBUSTED_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_LPG_COMBUSTED_PER_GROUP_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_LPG_COMBUSTED_PER_GROUP_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const getLpgCombustedPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_LPG_COMBUSTED_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_LPG_COMBUSTED_PER_FACILITY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_LPG_COMBUSTED_PER_FACILITY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRefrigerantGasTopUpsPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_REFRIGERANT_GAS_TOP_UP_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const getRefrigerantGasTopUpsPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_REFRIGERANT_GAS_TOP_UP_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getDryIcePurchasedPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_DRY_ICE_PURCHASED_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_DRY_ICE_PURCHASED_PER_GROUP_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_DRY_ICE_PURCHASED_PER_GROUP_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getDryIcePurchasedPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_DRY_ICE_PURCHASED_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_DRY_ICE_PURCHASED_PER_FACILITY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_DRY_ICE_PURCHASED_PER_FACILITY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getWasteGeneratedPerGroup = (company, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_WASTE_GENERATED_PER_GROUP + `/${company}/${year}/${type}`,
            config
        )
        if (type === 'waste-to-landfill') {
            dispatch({
                type: GET_WASTE_TO_LANDFILL_PER_GROUP_SUCCESS,
                payload: data,
            })
        }
        if (type === 'waste-to-recycling') {
            dispatch({
                type: GET_WASTE_TO_RECYCLING_PER_GROUP_SUCCESS,
                payload: data,
            })
        }
        if (type === 'waste-to-composting') {
            dispatch({
                type: GET_WASTE_TO_COMPOSTING_PER_GROUP_SUCCESS,
                payload: data,
            })
        }
        if (type === 'wastewater-treatment') {
            dispatch({
                type: GET_WASTEWATER_TREATMENT_PER_GROUP_SUCCESS,
                payload: data,
            })
        }
        if (type === 'waste-to-biochar-production') {
            dispatch({
                type: GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_SUCCESS,
                payload: data,
            })
        }
        dispatch(setAlert(data.detail, 'success'))
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === "waste-to-landfill") {
            dispatch({
                type: GET_WASTE_TO_LANDFILL_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === "waste-to-recycling") {
            dispatch({
                type: GET_WASTE_TO_RECYCLING_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === "waste-to-composting") {
            dispatch({
                type: GET_WASTE_TO_COMPOSTING_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === "wastewater-treatment") {
            dispatch({
                type: GET_WASTEWATER_TREATMENT_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === "waste-to-biochar-production") {
            dispatch({
                type: GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            })
        }

    }
}

export const getWasteGeneratedPerFacility = (company, group, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_WASTE_GENERATED_PER_FACILITY + `/${company}/${group}/${year}/${type}`, config
        )
        if (type === 'waste-to-landfill') {
            dispatch({
                type: GET_WASTE_TO_LANDFILL_PER_FACILITY_SUCCESS,
                payload: data,
            })
        }
        if (type === 'waste-to-composting') {
            dispatch({
                type: GET_WASTE_TO_COMPOSTING_PER_FACILITY_SUCCESS,
                payload: data,
            })
        }
        if (type === 'waste-to-recycling') {
            dispatch({
                type: GET_WASTE_TO_RECYCLING_PER_FACILITY_SUCCESS,
                payload: data,
            })
        }
        if (type === 'wastewater-treatment') {
            dispatch({
                type: GET_WASTEWATER_TREATMENT_PER_FACILITY_SUCCESS,
                payload: data,
            })
        }
        if (type === 'waste-to-biochar-production') {
            dispatch({
                type: GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_SUCCESS,
                payload: data,
            })
        }
        dispatch(setAlert(data.detail, 'success'))
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'))
        if (type === 'waste-to-landfill') {
            dispatch({
                type: GET_WASTE_TO_LANDFILL_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === 'waste-to-composting') {
            dispatch({
                type: GET_WASTE_TO_COMPOSTING_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === 'waste-to-recycling') {
            dispatch({
                type: GET_WASTE_TO_RECYCLING_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === 'wastewater-treatment') {
            dispatch({
                type: GET_WASTEWATER_TREATMENT_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            })
        }
        if (type === 'waste-to-biochar-production') {
            dispatch({
                type: GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            })
        }
    }

}

export const getFlightsAndAccommodationPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getFlightsAndAccommodationPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getCarHirePerGroup = (company, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_CAR_HIRE_PER_GROUP + `/${company}/${year}/${type}`,
            config
        );
        if (type === 'Diesel') {
            dispatch({
                type: GET_CAR_HIRE_DIESEL_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_CAR_HIRE_PETROL_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'Diesel') {
            dispatch({
                type: GET_CAR_HIRE_DIESEL_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_CAR_HIRE_PETROL_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
};

export const getCarHirePerFacility = (company, group, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_CAR_HIRE_PER_FACILITY + `/${company}/${group}/${year}/${type}`,
            config
        );
        if (type === 'Diesel') {
            dispatch({
                type: GET_CAR_HIRE_DIESEL_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_CAR_HIRE_PETROL_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'Diesel') {
            dispatch({
                type: GET_CAR_HIRE_DIESEL_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_CAR_HIRE_PETROL_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
};

export const getPetrolCardsPerGroup = (company, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_PETROL_CARDS_PER_GROUP + `/${company}/${year}/${type}`,
            config
        );
        if (type === 'Diesel') {
            dispatch({
                type: GET_PETROL_CARDS_DIESEL_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_PETROL_CARDS_PETROL_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'Diesel') {
            dispatch({
                type: GET_PETROL_CARDS_DIESEL_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_PETROL_CARDS_PETROL_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
}

export const getPetrolCardsPerFacility = (company, group, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_PETROL_CARDS_PER_FACILITY + `/${company}/${group}/${year}/${type}`,
            config
        );
        if (type === 'Diesel') {
            dispatch({
                type: GET_PETROL_CARDS_DIESEL_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_PETROL_CARDS_PETROL_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'Diesel') {
            dispatch({
                type: GET_PETROL_CARDS_DIESEL_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Petrol') {
            dispatch({
                type: GET_PETROL_CARDS_PETROL_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
}

export const getDownstreamDistributionPerGroup = (company, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_DOWNSTREAM_DISTRIBUTION_PER_GROUP + `/${company}/${year}/${type}`,
            config
        );
        if (type === 'Inter-DC Distribution') {
            dispatch({
                type: GET_INTER_DC_DISTRIBUTION_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Farm-DC Distribution') {
            dispatch({
                type: GET_FARM_DC_DISTRIBUTION_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Shipping Distribution') {
            dispatch({
                type: GET_SHIPPING_DISTRIBUTION_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Regional Distribution') {
            dispatch({
                type: GET_REGIONAL_DISTRIBUTION_PER_GROUP_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'Inter-DC Distribution') {
            dispatch({
                type: GET_INTER_DC_DISTRIBUTION_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Farm-DC Distribution') {
            dispatch({
                type: GET_FARM_DC_DISTRIBUTION_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Shipping Distribution') {
            dispatch({
                type: GET_SHIPPING_DISTRIBUTION_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Regional Distribution') {
            dispatch({
                type: GET_REGIONAL_DISTRIBUTION_PER_GROUP_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
}

export const getDownstreamDistributionPerFacility = (company, group, year, type) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_DOWNSTREAM_DISTRIBUTION_PER_FACILITY + `/${company}/${group}/${year}/${type}`,
            config
        );
        if (type === 'Inter-DC Distribution') {
            dispatch({
                type: GET_INTER_DC_DISTRIBUTION_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Farm-DC Distribution') {
            dispatch({
                type: GET_FARM_DC_DISTRIBUTION_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Shipping Distribution') {
            dispatch({
                type: GET_SHIPPING_DISTRIBUTION_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        if (type === 'Regional Distribution') {
            dispatch({
                type: GET_REGIONAL_DISTRIBUTION_PER_FACILITY_SUCCESS,
                payload: data,
            });
        }
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        if (type === 'Inter-DC Distribution') {
            dispatch({
                type: GET_INTER_DC_DISTRIBUTION_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Farm-DC Distribution') {
            dispatch({
                type: GET_FARM_DC_DISTRIBUTION_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Shipping Distribution') {
            dispatch({
                type: GET_SHIPPING_DISTRIBUTION_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
        if (type === 'Regional Distribution') {
            dispatch({
                type: GET_REGIONAL_DISTRIBUTION_PER_FACILITY_FAIL,
                payload: err.response.data.detail,
            });
        }
    }
};

export const getWaterPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_WATER_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_WATER_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_WATER_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getWaterPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_WATER_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_WATER_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_WATER_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getChemicalsAndAdditivesPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_CHEMICALS_AND_ADDITIVES_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getChemicalsAndAdditivesPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getWoodenProductsPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_WOODEN_PRODUCTS_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_WOODEN_PRODUCTS_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_WOODEN_PRODUCTS_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getWoodenProductsPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_WOODEN_PRODUCTS_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_WOODEN_PRODUCTS_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_WOODEN_PRODUCTS_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getPackagingPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_PACKAGING_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_PACKAGING_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_PACKAGING_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getPackagingPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_PACKAGING_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_PACKAGING_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_PACKAGING_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getWineAndGrapesPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_WINE_AND_GRAPES_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_WINE_AND_GRAPES_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_WINE_AND_GRAPES_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getWineAndGrapesPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_WINE_AND_GRAPES_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_WINE_AND_GRAPES_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_WINE_AND_GRAPES_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getOtherPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_OTHER_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_OTHER_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_OTHER_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getOtherPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_OTHER_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_OTHER_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_OTHER_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getFertilizersPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_FERTILIZERS_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_FERTILIZERS_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_FERTILIZERS_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getFertilizersPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_FERTILIZERS_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_FERTILIZERS_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_FERTILIZERS_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })

    }
}

export const getAgrochemicalsPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_AGROCHEMICALS_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_AGROCHEMICALS_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_AGROCHEMICALS_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getAgrochemicalsPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_AGROCHEMICALS_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_AGROCHEMICALS_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_AGROCHEMICALS_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getCapitalGoodsAndServicesPerGroup = (company, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP + `/${company}/${year}`,
            config
        );
        dispatch({
            type: GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getCapitalGoodsAndServicesPerFacility = (company, group, year) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(process.env.REACT_APP_API_URL + API_GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY + `/${company}/${group}/${year}`,
            config
        );
        dispatch({
            type: GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_SUCCESS,
            payload: data,
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const exportCompanyConsumptionSummary = (company, year) => async dispatch => {
    try {
        const response = await api().get(process.env.REACT_APP_API_URL + API_EXPORT_COMPANY_CONSUMPTION_SUMMARY + `/${company}/${year}`,
            {
                ...config,
                responseType: 'blob',
            }
        );
        dispatch({
            type: EXPORT_COMPANY_CONSUMPTION_SUCCESS,
            payload: response.data
        })
        dispatch(setAlert('Document Downloaded Successfully.', 'success'))
        return response
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: EXPORT_COMPANY_CONSUMPTION_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const exportGroupConsumptionSummary = (company, group, year) => async dispatch => {
    try {
        const response = await api().get(process.env.REACT_APP_API_URL + API_EXPORT_GROUP_CONSUMPTION_SUMMARY + `/${company}/${group}/${year}`,
            {
                ...config,
                responseType: 'blob',
            }
        );
        dispatch({
            type: EXPORT_GROUP_CONSUMPTION_SUCCESS,
            payload: response.data
        })
        dispatch(setAlert('Document Downloaded Successfully.', 'success'))
        return response
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: EXPORT_GROUP_CONSUMPTION_FAIL,
            payload: error.response.data.detail
        })
    }
}